import { mapValues, pickBy } from 'lodash';
import { redirect } from 'redux-first-router';

import { LOGOUT } from './actions/actionTypes/user';
import { ROUTES } from '../utils/routes';
import { PAGES } from '../utils/pages';

const routesMapBase = mapValues(pickBy(ROUTES, 'path'), ({ path, confirmLeave }) => ({
    path,
    confirmLeave
}));
const routesMap = {
    ...routesMapBase,
    [LOGOUT]: {
        thunk: dispatch => {
            dispatch(redirect({ type: PAGES.LOGIN }));
        }
    }
};

export { routesMap };
